<template>
  <div class="ui grid" style="width: 100%">
    <div class="row">
      <h1 class="ui huge header">News items</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <sui-button content="Add news item" positive icon="plus" v-on:click="showNewsModal(null)">
      </sui-button>
    </div>
    <div class="row">
      <news-table v-bind:news="news.news" v-bind:actions="newsActions" v-on:rowAction="rowAction" />
    </div>
    <!-- eslint-disable-next-line max-len -->
    <portal to="modal-destination">
      <sui-modal v-model="newsModalOpen">
        <sui-modal-header>News details</sui-modal-header>
        <sui-modal-content class="scrolling">
          <news-form v-bind:newsItem="newsItem" v-bind:error="newsError" v-on:saved="newsSaved" create="true"
            ref="newsForm" />
        </sui-modal-content>
        <sui-modal-actions>
          <sui-button negative v-on:click="hideNewsModal">
            Cancel
          </sui-button>
        </sui-modal-actions>
      </sui-modal>
    </portal>
    <div class="ui container center aligned">
      <sui-button v-if="hasPreviousPage" v-on:click="previousPage" content="Previous" />
      &nbsp;<span>Page: {{ this.paging.page }} of {{ totalPages }}</span>&nbsp;
      <sui-button v-if="hasNextPage" v-on:click="nextPage" content="Next" />
    </div>
  </div>
</template>

<script>
import NewsTable from '@/components/website/news/NewsTable';
import NewsForm from '@/components/website/news/NewsForm';
import { mapGetters } from 'vuex';

export default {
  name: 'NewsSelection',
  components: { NewsTable, NewsForm },
  computed: {
    hasNextPage() {
      return this.paging.page * this.paging.pageSize < this.news.newsCount;
    },
    hasPreviousPage() {
      return this.paging.page > 1;
    },
    totalPages() {
      return Math.ceil(this.news.newsCount / this.paging.pageSize);
    },
    ...mapGetters({
      news: 'pagedNews',
      paging: 'newsPaging',
    }),
  },
  data() {
    return {
      newsActions: ['Update', 'Delete'],
      newsModalOpen: false,
      newsError: null,
      includeArchived: false,
      currentNews: {
        data: null,
      },
      newsItem: null,
    };
  },
  methods: {
    rowAction(action) {
      switch (action.action) {
        case 'Update':
          this.showNewsModal(action.newsItem);
          break;
        case 'Delete':
          this.$dialog
            .confirm('Please confirm to remove this news item')
            .then(() => {
              this.$store
                .dispatch('deleteNews', action.newsItem)
                .then(
                  () => {
                    this.$store.dispatch('getPagedNews', this.paging);
                  },
                  (error) => {
                  },
                );
            })
            .catch(() => { });
          break;

        default:
          break;
      }
    },
    nextPage() {
      this.$store.dispatch('getPagedNews', {
        ...this.paging,
        page: this.paging.page + 1,
      });
    },
    previousPage() {
      this.$store.dispatch('getPagedNews', {
        ...this.paging,
        page: this.paging.page - 1,
      });
    },
    newsSaved() {
      this.$store
        .dispatch('createNews', this.newsItem)
        .then(() => {
          this.hideNewsModal();
        })
        .catch(() => { });
    },
    showNewsModal(item) {
      this.newsItem = item || {
        htmlContent: null,
      };
      this.newsError = null;
      this.$refs.newsForm.reset();
      this.newsModalOpen = true;
    },
    hideNewsModal() {
      this.newsModalOpen = false;
      this.$store.dispatch('getPagedNews', this.paging);
    },
  },
  created() {
    this.$store.dispatch('getPagedNews', this.paging);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/news/NewsSelection.vue